import React from 'react';
import { usePharmacyMode } from '@/contexts/PharmacyModeContext';
import { Link2, Shield, Lock, Unlock } from 'lucide-react';

export default function PharmacyModeBar() {
  const { isPharmacy, isConnected, isManual, primaryCompany, loading } = usePharmacyMode();

  if (!isPharmacy || loading) return null;

  if (isConnected) {
    return (
      <div className="flex items-center justify-between gap-3 px-4 py-2 bg-emerald-50 dark:bg-emerald-950/30 border-b border-emerald-200 dark:border-emerald-800/30" data-testid="pharmacy-mode-bar-connected">
        <div className="flex items-center gap-2">
          <Link2 className="w-4 h-4 text-emerald-600 dark:text-emerald-400" />
          <span className="text-xs font-semibold text-emerald-700 dark:text-emerald-300">
            Connected to: {primaryCompany || 'Company'}
          </span>
        </div>
        <div className="flex items-center gap-1 text-[10px] text-emerald-600/80 dark:text-emerald-400/60">
          <Lock className="w-3 h-3" />
          <span>Some fields are managed by company</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 bg-amber-50 dark:bg-amber-950/30 border-b border-amber-200 dark:border-amber-800/30" data-testid="pharmacy-mode-bar-manual">
      <div className="flex items-center gap-2">
        <Shield className="w-4 h-4 text-amber-600 dark:text-amber-400" />
        <span className="text-xs font-semibold text-amber-700 dark:text-amber-300">
          Manual Mode
        </span>
      </div>
      <div className="flex items-center gap-1 text-[10px] text-amber-600/80 dark:text-amber-400/60">
        <Unlock className="w-3 h-3" />
        <span>Full access — all data is private</span>
      </div>
    </div>
  );
}
